import { RegionS } from "@ugg/shared/utils/region-helpers";

export const REGION_OPTIONS = [
  { value: RegionS.NA, fullLabel: "North America", label: "NA" },
  { value: RegionS.EUW, fullLabel: "Europe West", label: "EUW" },
  { value: RegionS.EUN, fullLabel: "Europe Nordic & East", label: "EUN" },
  { value: RegionS.KR, fullLabel: "Korea", label: "KR" },
  { value: RegionS.BR, fullLabel: "Brazil", label: "BR" },
  { value: RegionS.JP, fullLabel: "Japan", label: "JP" },
  { value: RegionS.RU, fullLabel: "Russia", label: "RU" },
  { value: RegionS.OC, fullLabel: "Oceania", label: "OCE" },
  { value: RegionS.TR, fullLabel: "Turkey", label: "TR" },
  { value: RegionS.LA1, fullLabel: "Latin America North", label: "LAN" },
  { value: RegionS.LA2, fullLabel: "Latin America South", label: "LAS" },
  { value: RegionS.SG, fullLabel: "Southeast Asia", label: "SEA" },
  { value: RegionS.TW, fullLabel: "Taiwan", label: "TW" },
  { value: RegionS.VN, fullLabel: "Vietnam", label: "VN" },
  { value: RegionS.ME, fullLabel: "Middle East", label: "ME" },
];

export const REGION_OPTIONS_ALL = [{ value: RegionS.WORLD, fullLabel: "World", label: "World" }, ...REGION_OPTIONS];

export const REGION_LABEL_MAP: Record<string, string> = {
  [RegionS.NA]: "NA",
  [RegionS.EUW]: "EUW",
  [RegionS.EUN]: "EUN",
  [RegionS.KR]: "KR",
  [RegionS.BR]: "BR",
  [RegionS.JP]: "JP",
  [RegionS.RU]: "RU",
  [RegionS.OC]: "OCE",
  [RegionS.TR]: "TR",
  [RegionS.LA1]: "LAN",
  [RegionS.LA2]: "LAS",
  [RegionS.SG]: "SEA",
  [RegionS.TW]: "TW",
  [RegionS.VN]: "VN",
  [RegionS.ME]: "ME",
};
